import { render, staticRenderFns } from "./bo-return-search.vue?vue&type=template&id=1f97ed57"
import script from "./bo-return-search.vue?vue&type=script&lang=js"
export * from "./bo-return-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports